import { useTranslation } from "../i18n";
import { Copy } from "lucide-react";
import toast from "react-hot-toast";
import "./Contact.css";

// Image URLs from images.txt
const contactImages = {
  janina: "https://cdn.mupende.com/u/VDZkNB.png",
  charles: "https://cdn.mupende.com/u/HgJdU2.png",
  dominik: "https://cdn.mupende.com/u/pwTUeJ.png",
  esther: "https://cdn.mupende.com/u/RWKFvy.png",
  franscesca: "https://cdn.mupende.com/u/JL4RWE.png",
};

function Contact() {
  const { t } = useTranslation();

  const contacts = [
    {
      name: "Janina Cichon",
      roleKey: "contact.roles.braut",
      phone: "+49 151 57358600",
      email: "janina.cichon96@gmail.com",
      category: "planning",
      imageKey: "janina",
    },
    {
      name: "Charles David Mupende",
      roleKey: "contact.roles.braeutigam",
      phone: "+49 179 4157744",
      email: "charlesdavid@mupende.com",
      category: "planning",
      imageKey: "charles",
    },
    {
      name: "Francesca Ogrzall",
      roleKey: "contact.roles.trauzeugin",
      phone: "+49 1511 2083925",
      email: "anna_francesca@web.de",
      category: "planning",
      imageKey: "franscesca",
    },
    {
      name: "Dominik Vasic",
      roleKey: "contact.roles.trauzeuge",
      phone: "+49 157 50119174",
      email: "dominikvasic1993@outlook.de",
      category: "planning",
      imageKey: "dominik",
    },
    {
      name: "Esther Mupende",
      roleKey: "contact.roles.escalator",
      phone: "+49 159 01296358",
      email: "e.mupende@gmx.de",
      category: "support",
      imageKey: "esther",
    },
  ];

  const handlePhoneClick = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
    toast.success(t("contact.copied"));
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case "planning":
        return "#2a2a21";
      case "venue":
        return "#27ae60";
      case "service":
        return "#3498db";
      case "emergency":
        return "#e74c3c";
      default:
        return "#95a5a6";
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case "planning":
        return "👰";
      case "venue":
        return "🏛️";
      case "service":
        return "⚙️";
      case "emergency":
        return "🚨";
      default:
        return "📞";
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-header">
        <h2 className="contact-title">{t("contact.title")}</h2>
        <p className="contact-subtitle">{t("contact.subtitle")}</p>
      </div>

      <div className="contact-grid">
        {contacts.map((contact, index) => (
          <div key={index} className="contact-card">
            <div className="contact-header-info">
              <div className="contact-avatar">
                <img
                  src={contactImages[contact.imageKey]}
                  alt={contact.name}
                  className="contact-avatar-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="contact-name-section">
                <h3 className="contact-name">{contact.name}</h3>
                <p className="contact-role">{t(contact.roleKey)}</p>
              </div>
            </div>

            <div className="contact-details">
              {contact.address && (
                <div className="contact-item">
                  <span className="contact-label">
                    {t("contact.labels.address")}
                  </span>
                  <span className="contact-value">{contact.address}</span>
                </div>
              )}

              <div className="contact-item">
                <span className="contact-label">
                  {t("contact.labels.phone")}
                </span>
                <div className="contact-value-group">
                  <span
                    className="contact-value clickable"
                    onClick={() => handlePhoneClick(contact.phone)}
                  >
                    {contact.phone}
                  </span>
                  <button
                    className="copy-button"
                    onClick={() => copyToClipboard(contact.phone)}
                    title={t("contact.copy")}
                  >
                    <Copy size={14} />
                  </button>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-label">
                  {t("contact.labels.email")}
                </span>
                <div className="contact-value-group">
                  <span
                    className="contact-value clickable"
                    onClick={() => handleEmailClick(contact.email)}
                  >
                    {contact.email}
                  </span>
                  <button
                    className="copy-button"
                    onClick={() => copyToClipboard(contact.email)}
                    title={t("contact.copy")}
                  >
                    <Copy size={14} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Contact;
